import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ModalPayloadProps, ProjectItem, UIProps } from "../../types/interface";
import { stat } from "fs";

const initialState: UIProps = {
  modalOpen: {
    name: "",
    project: {
      id: "",
      name: "",
      imageUrl: "",
      thubmImageUrl: "",
      description: "",
      liked: false,
      labels: 0,
      images: 0,
      annotations: 0,
      models: 0,
      taskTypeId: "",
      domainTypeId: "",
      customerId: "",
      createdDate: "",
      isAnnotate: false,
      isImageUpload: false,
    },
    isOpen: false,
    videoFile: undefined,
    taskType: "",
  },
  isDrawerTopOpen: false,
  isDrawerLeftOpen: false,
  isDrawerRightOpen: false,
  isDrawerBottomOpen: false,
  isSpinnerLoading: false,
  topBarTitle: "",
  spinnerText: "Loading...",
};

const UISlice = createSlice({
  name: "uiSlice",
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<ModalPayloadProps>) => {
      state.modalOpen.name = action.payload.name;
      state.modalOpen.taskType = action.payload.taskType;
      if (action.payload.project) {
        state.modalOpen.project = action.payload.project;
      } else {
        state.modalOpen.project = {
          id: "",
          name: "",
          imageUrl: "",
          thubmImageUrl: "",
          description: "",
          liked: false,
          labels: 0,
          images: 0,
          annotations: 0,
          models: 0,
          taskTypeId: "",
          domainTypeId: "",
          customerId: "",
          createdDate: "",
        };
      }

      if (action.payload.videoFile) {
        state.modalOpen.videoFile = action.payload.videoFile;
      } else {
        state.modalOpen.videoFile = null;
      }

      state.modalOpen.isOpen = true;
    },
    loadProjectData: (state, action: PayloadAction<ProjectItem>) => {
      state.modalOpen.project = action.payload;
    },
    closeModal: (state) => {
      state.modalOpen.isOpen = false;
    },
    drawerTop: (state) => {
      state.isDrawerTopOpen = !state.isDrawerTopOpen;
    },
    drawerBottom: (state) => {
      state.isDrawerBottomOpen = !state.isDrawerBottomOpen;
    },
    drawerRight: (state) => {
      state.isDrawerRightOpen = !state.isDrawerRightOpen;
    },
    drawerLeft: (state) => {
      state.isDrawerLeftOpen = !state.isDrawerLeftOpen;
    },
    startSpinner: (state, action) => {
      state.isSpinnerLoading = true;
      state.spinnerText = action.payload;
    },
    stopSpinner: (state) => {
      state.isSpinnerLoading = false;
    },
    setTopBarTitle: (state, action: PayloadAction<string>) => {
      state.topBarTitle = action.payload;
    },
  },
});

export const {
  openModal,
  closeModal,
  drawerTop,
  drawerBottom,
  drawerLeft,
  drawerRight,
  startSpinner,
  stopSpinner,
  setTopBarTitle,
  loadProjectData,
} = UISlice.actions;

export default UISlice.reducer;
